module.exports = __webpack_public_path__ + "media/icons/twitter-79d244a0.png";